import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login'
import manage from '../views/Home'
import DataPage from '../components/dataPage'
import Extension from '../components/extension.vue'
import Order from '../components/order.vue'
import Change from '../components/change.vue'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)


const routes = [{
        path: '/',
        redirect: 'manage'
    }, {
        path: '/login',
        name: 'login',
        component: login
    }, {
        path: '/manage',
        component: manage,
        children: [{
                path: '',
                name: '',
                component: DataPage
            },
            {
                path: '/DataPage',
                name: 'DataPage',
                component: DataPage
            },
            {
                path: '/extension',
                name: 'Extension',
                component: Extension
            },
            {
                path: '/order',
                name: 'Order',
                component: Order
            },
            {
                path: '/change',
                name: 'Change',
                component: Change
            }
        ]
    },

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    const isLogin = sessionStorage.getItem('account')
    if (isLogin) {
        next()
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }
    }
})
export default router